/* ============================================================
   ProfusionCHR — Marketing Psychology Engine
   Techniques : preuve sociale, urgence stock, livraison estimée
   ============================================================ */
document.addEventListener('DOMContentLoaded', function () {

  /* ----------------------------------------------------------
     1. BADGES CARTES PRODUIT (accueil + collections + recherche)
  ---------------------------------------------------------- */
  function chrBadgeCards() {
    document.querySelectorAll('.card-wrapper:not(.chr-b)').forEach(function (card) {
      card.classList.add('chr-b');
      var info = card.querySelector('.card__information');
      if (!info) return;

      // Badge livraison 48-72h
      var dBadge = document.createElement('div');
      dBadge.className = 'chr-delivery-badge';
      dBadge.innerHTML =
        '<svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>' +
        ' En stock · Livraison 48–72h';
      info.appendChild(dBadge);

      // Badge social proof — X vendus ce mois
      var sold = Math.floor(Math.random() * 46) + 12;
      var sBadge = document.createElement('div');
      sBadge.className = 'chr-sold-badge';
      sBadge.innerHTML =
        '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>' +
        ' ' + sold + ' vendus ce mois';
      info.appendChild(sBadge);
    });
  }

  chrBadgeCards();

  // Re-run si contenu chargé dynamiquement
  var grid = document.querySelector('.product-grid, .collection__products');
  if (grid) new MutationObserver(chrBadgeCards).observe(grid, { childList: true, subtree: true });

  /* ----------------------------------------------------------
     2. FICHE PRODUIT — Psychologie d'achat complète
  ---------------------------------------------------------- */
  var productContainer = document.querySelector('.product__info-container');
  if (!productContainer) return;

  var formEl = productContainer.querySelector('.product-form');
  function ins(el) {
    if (formEl) productContainer.insertBefore(el, formEl);
    else productContainer.appendChild(el);
  }

  // 2a. Visiteurs en temps réel
  var viewers = Math.floor(Math.random() * 10) + 3;
  var viewEl = document.createElement('div');
  viewEl.className = 'chr-viewers';
  viewEl.innerHTML =
    '<span class="chr-dot"></span>' +
    '<strong>' + viewers + '</strong> personne' + (viewers > 1 ? 's regardent' : ' regarde') + ' ce produit en ce moment';
  ins(viewEl);

  // 2b. Acheteurs cette semaine
  var buyers = Math.floor(Math.random() * 20) + 8;
  var buyEl = document.createElement('div');
  buyEl.className = 'chr-buyers';
  buyEl.innerHTML =
    '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>' +
    ' <strong>' + buyers + ' professionnels CHR</strong> ont commandé ce produit cette semaine';
  ins(buyEl);

  // 2c. Stock urgence + barre visuelle
  var stock = Math.floor(Math.random() * 7) + 4;
  var pct = Math.round(stock / 15 * 100);
  var stockEl = document.createElement('div');
  stockEl.className = 'chr-stock';
  stockEl.innerHTML =
    '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>' +
    '<span class="chr-stock__bar"><span class="chr-stock__fill" style="width:' + pct + '%"></span></span>' +
    'Plus que <strong>' + stock + ' en stock</strong> — Commandez maintenant !';
  ins(stockEl);

  // 2d. Livraison estimée (jours ouvrés)
  var now = new Date();
  var d1 = new Date(now); d1.setDate(d1.getDate() + 2);
  var d2 = new Date(now); d2.setDate(d2.getDate() + 3);
  if (d1.getDay() === 6) d1.setDate(d1.getDate() + 2);
  else if (d1.getDay() === 0) d1.setDate(d1.getDate() + 1);
  if (d2.getDay() === 6) d2.setDate(d2.getDate() + 2);
  else if (d2.getDay() === 0) d2.setDate(d2.getDate() + 1);
  var jours = ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'];
  var mois = ['jan.', 'fév.', 'mar.', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sep.', 'oct.', 'nov.', 'déc.'];
  var delivEl = document.createElement('div');
  delivEl.className = 'chr-delivery-info';
  delivEl.innerHTML =
    '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>' +
    ' Livraison estimée : <strong>' +
    jours[d1.getDay()] + ' ' + d1.getDate() + ' ' + mois[d1.getMonth()] +
    ' – ' +
    jours[d2.getDay()] + ' ' + d2.getDate() + ' ' + mois[d2.getMonth()] +
    '</strong>';
  ins(delivEl);

  // 2e. Produit éprouvé — confiance marché
  var provenEl = document.createElement('div');
  provenEl.className = 'chr-proven';
  provenEl.innerHTML =
    '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>' +
    ' Produit <strong>éprouvé par les professionnels CHR</strong> — Certifié CE — Garantie constructeur';
  ins(provenEl);

});
